import React, {useContext, useEffect, useRef, useState} from 'react';
import $ from 'jquery';

import {useTranslation} from "react-i18next";
import {DataGrid, GridToolbar} from '@mui/x-data-grid';


import moment from 'moment';

import Swal from 'sweetalert2';

import Button from '@mui/material/Button';
import {styled} from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import {useNavigate} from "react-router-dom";
import { frFR, enUS } from '@mui/x-data-grid';
import {LinearProgress} from "@mui/material";
import OrgContext from "../../../organisation/OrgContext";
import jwtInterceoptor from "../../../components/shared/jwtInterceptor";
import { toast, ToastContainer } from "react-toastify";


const BootstrapDialog = styled(Dialog)(({theme}) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

function BootstrapDialogTitle(props) {
    const {children, onClose, ...other} = props;

    return (
        <DialogTitle sx={{m: 0, p: 2}} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    x
                </IconButton>
            ) : null}
        </DialogTitle>
    );
}

function CsList(props) {

    const [t, i18n] = useTranslation();

    const {organisation} = useContext(OrgContext);

    const [pieces, setPieces] = useState([]);

    const navigate = useNavigate();

    const [csAccounts, setCsAccounts] = useState([]);
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        if (organisation.id) {
            fetchCsAccounts();
        }
    }, []);
    const fetchCsAccounts = async () => {
        await jwtInterceoptor.get('/data/user/cs/accounts/' + organisation.id,).then(res => {
            setCsAccounts(res.data.data);
            setLoaded(true);
        }).catch((error) => {
            console.log(error)
        });
    }

    /**
     *
     * @param inv
     * @return {Promise<void>}
     */
    const deleteItem = async (inv) => {
        Swal.fire({
            title: t('Are you sure?'),
            text: t("You won't be able to revert this!"),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: t('Yes, delete it!'),
            cancelButtonText: t("Cancel")
        }).then(async (result) => {
            if (result.isConfirmed) {

                const response = await jwtInterceoptor.delete(`/data/user/accounts/${inv.id}`);

                if (response.status === 200) {
                    if (response.data.status === true) {
                        let accounts = csAccounts.filter(account => account.id !== inv.id);
                        setCsAccounts(accounts);
                        Swal.fire(
                            t('Deleted!'),
                            t('Your record has been deleted.'),
                            'success'
                        )
                        return;
                    }else{
                        toast.error("Vous ne pouvez pas supprimer un compte dans lequel une transaction a été effectuée !", {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: false,
                            draggable: true,
                            progress: undefined,
                            theme: "colored",
                        });
                    }

                }



            }
        })
    }

    const columns = [
        {
            field: 'Code',
            headerName: t("Code"),
            valueGetter: (params) =>
                params.row.code,
            width: 100,
        },
        {
            field: 'Libellé',
            headerName: t("Libellé"),
            valueGetter: (params) =>
                params.row.name,
            width: 260,
        },
        {
            field: 'Description',
            headerName: t("Description"),
            valueGetter: (params) =>
                params.row.description,
            width: 260,
        },
        {
            field: 'action',
            headerName: t("ACTIONS"),
            width: 80,
            sortable: false,
            disableClickEventBubbling: true,
            renderCell: (params) => {
                const onEdit = (e) => {
                    const currentRow = params.row;
                    navigate("/cs/edit/"+currentRow?.id);
                };

                const onDelete = (e) => {
                    const inv = params.row;
                    return deleteItem(inv);
                };

                return (
                    <div className="btn-list">
                        <button onClick={onEdit} id="bDel" type="button" className="btn  btn-sm btn-primary">
                            <span className="fe fe-edit"> </span>
                        </button>
                        <button onClick={onDelete} id="bDel" type="button" className="btn  btn-sm btn-danger">
                            <span className="fe fe-trash-2"> </span>
                        </button>
                    </div>
                );
            },
        }
    ];

    return (
        <>
            <ToastContainer />

            <div className="row" style={{zIndex: 1}}>
                <div className="col-lg-12">
                    <div className="card">
                        <div className="card-header container-fluid row">
                            <div className="col-md-9 col-sm-12 card-title">{t("Gestion des comptes comptable de la caisse")}</div>
                            <div className="col-md-3 card-title">
                  <button className="btn btn-primary" onClick={()=>{navigate("/cs/add")}}>
                    Ajouter une compte comptable de la caisse
                  </button>
              </div>
                        </div>
                        <div className="card-body">
                            <div className="table-responsive">
                                <div style={{height: 600, width: '100%'}}>
                                    <DataGrid
                                        rows={csAccounts}
                                        columns={columns}
                                        pagination={false}
                                        localeText={
                                            i18n.language === "fr" ?
                                                frFR.components.MuiDataGrid.defaultProps.localeText :
                                                enUS.components.MuiDataGrid.defaultProps.localeText
                                        }
                                        slotProps={{
                                            toolbar: {
                                                printOptions: { disableToolbarButton: true },
                                                csvOptions: { disableToolbarButton: true },
                                            }}
                                        }
                                        slots={{
                                            loadingOverlay: LinearProgress,
                                            toolbar: GridToolbar
                                        }}
                                        loading={!loaded}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default CsList;